import { render, staticRenderFns } from "./ordersale.vue?vue&type=template&id=3f68eadd&scoped=true&"
import script from "./ordersale.vue?vue&type=script&lang=js&"
export * from "./ordersale.vue?vue&type=script&lang=js&"
import style0 from "./ordersale.vue?vue&type=style&index=0&id=3f68eadd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f68eadd",
  null
  
)

export default component.exports